package it.maicol07.gamerlogue.ui.theme

import androidx.compose.ui.unit.dp

/**
 * Shared structural spacing used across screens.
 * ponytail: only the values repeated in 2+ files live here — not a full design-system scale.
 */
object Dimens {
    /** Standard horizontal screen / section padding. */
    val ScreenPadding = 16.dp

    /** Gap between major vertical sections of a screen. */
    val SectionGap = 12.dp

    /** Gap between items inside a row/section (chips, tiles, titles). */
    val ItemGap = 8.dp

    /** Gap between cards in a grid/carousel. */
    val CardGap = 12.dp
}
